import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punetoshirdidarshanpackage() {



    const cardData = {

keyword: "Pune to Shirdi Darshan Package",

headingDescription:
    "Rising Cab Service offers comfortable and affordable Pune to Shirdi Darshan Package for devotees, families, and groups planning a peaceful pilgrimage to Sai Baba’s holy shrine. We provide well-maintained Sedan, SUV, Innova Crysta, Tempo Traveller, and Urbania vehicles with experienced drivers for a safe and smooth journey. Our service includes flexible one-way and round-trip options with doorstep pickup from Pune, transparent pricing, and 24/7 booking support. Rising Cab Service ensures a stress-free and devotional travel experience to Shirdi.",

topPlaces: [
    {
        title: "Shri Sai Baba Samadhi Mandir",
        description:
            "Shri Sai Baba Samadhi Mandir is the main attraction of Shirdi and the final resting place of Sai Baba. Devotees from across the world visit the temple daily to seek blessings. The temple is known for its peaceful atmosphere, organized darshan system, and strong spiritual energy."
    },
    {
        title: "Dwarkamai Mosque",
        description:
            "Dwarkamai Mosque is a sacred place where Sai Baba spent most of his life. It contains the holy dhuni (eternal fire) that is still burning today. The mosque holds deep spiritual significance and is visited by devotees seeking blessings and guidance."
    },
    {
        title: "Chavadi",
        description:
            "Chavadi is another important site associated with Sai Baba, where he used to sleep on alternate nights. The place is preserved with historical items and reflects the simple lifestyle of Sai Baba during his time in Shirdi."
    },
    {
        title: "Gurusthan",
        description:
            "Gurusthan is believed to be the place where Sai Baba was first seen as a young ascetic under a neem tree. It is considered highly sacred and is visited by devotees for meditation and blessings."
    },
    {
        title: "Shani Shingnapur",
        description:
            "Shani Shingnapur is a famous temple dedicated to Lord Shani located near Shirdi. The village is known for its unique tradition of houses without doors and strong belief in divine protection."
    },
    {
        title: "Khandoba Temple",
        description:
            "Khandoba Temple in Shirdi is the place where Sai Baba was first welcomed into the village. It holds historical importance and is often included in Shirdi pilgrimage tours."
    },
    {
        title: "Sai Heritage Village",
        description:
            "Sai Heritage Village is a theme park showcasing the life and times of Sai Baba through live shows, replicas, and cultural displays. It provides visitors with an educational and spiritual experience."
    },
    {
        title: "Lendi Baug",
        description:
            "Lendi Baug is a peaceful garden where Sai Baba used to water plants daily. It is now a serene spot filled with greenery and a memorial dedicated to his spiritual presence."
    },
    {
        title: "Wet N Joy Water Park",
        description:
            "Wet N Joy Water Park near Shirdi is a popular recreational destination for families and tourists. It offers water slides, pools, and fun activities for relaxation after darshan."
    },
    {
        title: "Sai Teerth Devotional Theme Park",
        description:
            "Sai Teerth is India’s first devotional theme park dedicated to Sai Baba, featuring 4D shows, spiritual experiences, and interactive exhibits that narrate his life and teachings."
    }
],



services: [
    {
        name: "Pune to shirdi package tour",
        description:
            "Rising Cab Service offers Pune to shirdi package tour for devotees, families, and groups planning a comfortable pilgrimage to the holy shrine of Sai Baba. Our packages include well-maintained AC cabs, experienced drivers, flexible pickup and drop service from Pune, and customizable itineraries covering Shirdi temple darshan, local sightseeing, and nearby spiritual spots for a peaceful and memorable journey."
    },
    {
        name: "Shirdi and shani shingnapur darshan package from pune",
        description:
            "Book Shirdi and shani shingnapur darshan package from pune with Rising Cab Service for a complete spiritual tour experience. This package covers two of Maharashtra’s most famous pilgrimage destinations with comfortable cab travel, professional drivers, and well-planned routes ensuring a smooth and stress-free journey for families and devotees."
    },
    {
        name: "Shirdi darshan package from pune",
        description:
            "Rising Cab Service provides Shirdi darshan package from pune designed for safe, convenient, and comfortable travel to Sai Baba’s holy shrine. Our service includes door-to-door pickup, AC vehicles, and flexible travel options suitable for one-day and overnight pilgrimage trips."
    },
    {
        name: "Pune to Shirdi Darshan Package",
        description:
            "Our Pune to Shirdi Darshan Package offers a complete travel solution for devotees visiting Shirdi. With comfortable cabs, experienced drivers, and customizable schedules, Rising Cab Service ensures a peaceful and well-organized spiritual journey."
    },
    {
        name: "Pune to Shirdi Tour Package",
        description:
            "Rising Cab Service offers Pune to Shirdi Tour Package for families, groups, and solo travelers seeking a comfortable pilgrimage experience. The package includes reliable transportation, flexible timing, and optional sightseeing stops along the route."
    },
    {
        name: "Pune to Shirdi Cab Package",
        description:
            "Book Pune to Shirdi Cab Package with Rising Cab Service for affordable and comfortable travel. Our fleet includes sedans, SUVs, Innova Crysta, and tempo travellers ensuring suitable options for every group size and budget."
    },
    {
        name: "Pune to Shirdi Sai Baba Darshan Package",
        description:
            "Rising Cab Service provides Pune to Shirdi Sai Baba Darshan Package with complete pilgrimage arrangements including comfortable travel, priority temple visits, and experienced drivers for a smooth spiritual experience."
    },
    {
        name: "Pune to Shirdi Darshan Cab",
        description:
            "Our Pune to Shirdi Darshan Cab service ensures safe and reliable travel to Shirdi with well-maintained vehicles and professional drivers. Ideal for families and devotees seeking a hassle-free temple visit."
    },
    {
        name: "Pune to Shirdi One Day Tour",
        description:
            "Rising Cab Service offers Pune to Shirdi One Day Tour for quick and convenient pilgrimage trips. Enjoy same-day return travel with comfortable AC cabs and well-planned darshan arrangements."
    },
    {
        name: "Pune to Shirdi Round Trip Cab",
        description:
            "Book Pune to Shirdi Round Trip Cab with Rising Cab Service for a complete pilgrimage journey including pickup, temple visit, waiting time, and return travel with experienced drivers."
    },
    {
        name: "Pune to Shirdi Innova Crysta Cab",
        description:
            "Rising Cab Service provides Pune to Shirdi Innova Crysta Cab for premium comfort, spacious seating, and smooth highway travel, ideal for families and group pilgrims."
    },
    {
        name: "Pune to Shirdi Online Cab Booking",
        description:
            "Our Pune to Shirdi Online Cab Booking system allows easy and quick reservation of cabs with transparent pricing, multiple vehicle options, and instant confirmation for a hassle-free experience."
    },
    {
        name: "Pune to Shirdi Pilgrimage Tour",
        description:
            "Rising Cab Service offers Pune to Shirdi Pilgrimage Tour for devotees seeking a peaceful and well-organized spiritual journey with reliable transport and flexible travel plans."
    },
    {
        name: "Pune to Nashik Darshan Package",
        description:
            "Book Pune to Nashik Darshan Package with Rising Cab Service for visits to famous temples including Trimbakeshwar and other spiritual destinations with comfortable cab travel and experienced drivers."
    },
    {
        name: "Pune to Nashik Tour Package",
        description:
            "Rising Cab Service provides Pune to Nashik Tour Package for families and groups looking to explore Nashik’s religious and scenic attractions with safe and comfortable transportation."
    },
    {
        name: "Pune to Trimbakeshwar Darshan Package",
        description:
            "Our Pune to Trimbakeshwar Darshan Package offers a spiritual journey to one of the twelve Jyotirlingas with reliable cab service, experienced drivers, and flexible scheduling."
    },
    {
        name: "Pune to Nashik Darshan Cab",
        description:
            "Rising Cab Service offers Pune to Nashik Darshan Cab for comfortable temple visits and sightseeing with clean vehicles and professional drivers."
    },
    {
        name: "Pune to Nashik One Day Tour",
        description:
            "Book Pune to Nashik One Day Tour for a quick and convenient spiritual trip covering major temples and attractions with same-day return facility."
    },
    {
        name: "Pune to Nashik Sightseeing Package",
        description:
            "Rising Cab Service provides Pune to Nashik Sightseeing Package for tourists and devotees wanting a relaxed and well-planned travel experience."
    },
    {
        name: "Pune to Nashik Taxi Service",
        description:
            "Our Pune to Nashik Taxi Service ensures safe, affordable, and comfortable intercity travel with experienced drivers and flexible booking options."
    },
    {
        name: "Pune to Nashik Innova Crysta Cab",
        description:
            "Rising Cab Service offers Pune to Nashik Innova Crysta Cab for premium travel comfort, ideal for families and group tours."
    },
    {
        name: "Pune to Nashik Pilgrimage Tour",
        description:
            "Book Pune to Nashik Pilgrimage Tour with Rising Cab Service for a spiritual journey covering Trimbakeshwar and other sacred destinations."
    },
    {
        name: "Pune to Nashik Online Cab Booking",
        description:
            "Rising Cab Service provides Pune to Nashik Online Cab Booking with instant confirmation, transparent pricing, and multiple vehicle options for easy travel planning."
    },
    {
        name: "Pune to Aurangabad Darshan Package",
        description:
            "Our Pune to Aurangabad Darshan Package offers comfortable travel to historical and spiritual destinations including Ajanta and Ellora caves with experienced drivers."
    },
    {
        name: "Pune to Aurangabad Tour Package",
        description:
            "Rising Cab Service provides Pune to Aurangabad Tour Package for tourists and families looking to explore heritage sites and cultural attractions."
    },
    {
        name: "Pune to Aurangabad Darshan Cab",
        description:
            "Book Pune to Aurangabad Darshan Cab for a safe and comfortable journey with professional drivers and well-maintained vehicles."
    },
    {
        name: "Pune to Aurangabad Sightseeing Package",
        description:
            "Rising Cab Service offers Pune to Aurangabad Sightseeing Package covering Ajanta caves, Ellora caves, and other famous tourist spots."
    },
    {
        name: "Pune to Ellora Caves Tour Package",
        description:
            "Our Pune to Ellora Caves Tour Package provides a complete heritage travel experience with comfortable cab service and guided sightseeing."
    }
],

tableData: [
    ["Pune to shirdi package tour", "Shirdi and shani shingnapur darshan package from pune"],
    ["Shirdi darshan package from pune", "Pune to Shirdi Darshan Package"],
    ["Pune to Shirdi Tour Package", "Pune to Shirdi Cab Package"],
    ["Pune to Shirdi Sai Baba Darshan Package", "Pune to Shirdi Darshan Cab"],
    ["Pune to Shirdi One Day Tour", "Pune to Shirdi Round Trip Cab"],
    ["Pune to Shirdi Innova Crysta Cab", "Pune to Shirdi Online Cab Booking"],
    ["Pune to Shirdi Pilgrimage Tour", "Pune to Nashik Darshan Package"],
    ["Pune to Nashik Tour Package", "Pune to Trimbakeshwar Darshan Package"],
    ["Pune to Nashik Darshan Cab", "Pune to Nashik One Day Tour"],
    ["Pune to Nashik Sightseeing Package", "Pune to Nashik Taxi Service"],
    ["Pune to Nashik Innova Crysta Cab", "Pune to Nashik Pilgrimage Tour"],
    ["Pune to Nashik Online Cab Booking", "Pune to Aurangabad Darshan Package"],
    ["Pune to Aurangabad Tour Package", "Pune to Aurangabad Darshan Cab"],
    ["Pune to Aurangabad Sightseeing Package", "Pune to Ellora Caves Tour Package"]
],


whychoose: [
    {
        WhyChooseheading: "Reliable Pune to Shirdi Darshan Package",
        WhyChoosedescription: "Rising Cab Service offers well-planned Pune to Shirdi Darshan Packages for Sai Baba devotees seeking a comfortable, safe, and spiritually fulfilling journey."
    },
    {
        WhyChooseheading: "Comfortable Vehicles for Pilgrimage Travel",
        WhyChoosedescription: "Our fleet includes Sedan cars, Ertiga, Innova Crysta, SUVs, Tempo Travellers, and Mini Buses suitable for individuals, families, and group pilgrims."
    },
    {
        WhyChooseheading: "Same-Day and Multi-Day Darshan Packages",
        WhyChoosedescription: "We provide flexible travel options including same-day Shirdi Darshan, overnight trips, and customized pilgrimage packages according to customer requirements."
    },
    {
        WhyChooseheading: "Affordable Shirdi Tour Packages",
        WhyChoosedescription: "Rising Cab Service offers budget-friendly Pune to Shirdi Darshan Packages with transparent pricing and excellent travel convenience."
    },
    {
        WhyChooseheading: "Cover Major Religious Attractions",
        WhyChoosedescription: "The package includes visits to Sai Baba Samadhi Mandir, Dwarkamai, Chavadi, Gurusthan, Lendi Baug, and other important spiritual places in Shirdi."
    },
    {
        WhyChooseheading: "Experienced Drivers for Pilgrimage Routes",
        WhyChoosedescription: "Our professional drivers are familiar with the Pune-Shirdi route and ensure a smooth, safe, and comfortable travel experience."
    },
    {
        WhyChooseheading: "Pickup Available Across Pune & PCMC",
        WhyChoosedescription: "We provide pickup services from Hinjewadi, Baner, Wakad, Kharadi, Hadapsar, Viman Nagar, Kothrud, Pimpri Chinchwad, Pune Airport, and nearby locations."
    },
    {
        WhyChooseheading: "Perfect for Families and Devotee Groups",
        WhyChoosedescription: "Our Shirdi Darshan Packages are ideal for families, senior citizens, religious groups, corporate groups, and Sai Baba devotees from across Pune."
    }
]
};

const faqData = [
    {
        question: "Do you provide Pune to Shirdi Darshan Packages?",
        answer: "Yes, Rising Cab Service offers dedicated Pune to Shirdi Darshan Packages for individuals, families, and groups."
    },
    {
        question: "How far is Shirdi from Pune?",
        answer: "Shirdi is approximately 190 to 210 kilometers from Pune depending on the route and pickup location."
    },
    {
        question: "Which places are covered in the Shirdi Darshan Package?",
        answer: "The package covers Sai Baba Samadhi Mandir, Dwarkamai, Chavadi, Gurusthan, Lendi Baug, and other important religious sites in Shirdi."
    },
    {
        question: "Do you offer same-day Shirdi Darshan trips?",
        answer: "Yes, customers can choose same-day return packages as well as overnight pilgrimage tours."
    },
    {
        question: "Which vehicles are available for the trip?",
        answer: "We provide Sedan cars, Ertiga, Innova Crysta, SUVs, Tempo Travellers, and Mini Buses."
    },
    {
        question: "Can senior citizens comfortably travel to Shirdi?",
        answer: "Yes, our vehicles are well-maintained and suitable for senior citizens, families, and pilgrims."
    },
    {
        question: "Do you provide pickup from Pune Airport and Railway Station?",
        answer: "Yes, pickup services are available from Pune Airport, Railway Station, hotels, homes, and major Pune locations."
    },
    {
        question: "Can I customize my Shirdi tour package?",
        answer: "Yes, we provide customized Shirdi Darshan itineraries according to your travel requirements."
    },
    {
        question: "Are your drivers experienced on the Pune-Shirdi route?",
        answer: "Yes, our drivers regularly operate pilgrimage tours and are familiar with all major routes and destinations."
    },
    {
        question: "How can I book a Pune to Shirdi Darshan Package?",
        answer: "You can book your package through phone, WhatsApp, or online booking with Rising Cab Service."
    }
];

const testimonials = [
    {
        id: 1,
        name: "Mr. Ashok Deshpande",
        feedback:
            "Our Shirdi Darshan journey was peaceful and comfortable. The vehicle was clean, the driver was courteous, and the entire trip was managed professionally.",
        rating: 5
    },
    {
        id: 2,
        name: "Mrs. Sunita Patil",
        feedback:
            "Rising Cab Service provided an excellent pilgrimage experience for our family. Timely pickup, comfortable travel, and smooth arrangements made the trip truly memorable.",
        rating: 5
    }
];













    const Images = [
        { place: "/images/keyword/1.jpg", text: "Pune Darshan Cab", link: "Pune-Darshan-Cab" },
        { place: "/images/keyword/2.jpg", text: "Pune to Bhimashankar Cab", link: "Pune-to-Bhimashankar-Cab" },
        { place: "/images/keyword/3.jpg", text: "Pimpri Chinchwad to Bhimashankar Cab", link: "Pimpri-Chinchwad-to-Bhimashankar-Cab" },
        { place: "/images/keyword/4.jpg", text: "Pune to Jejuri Cab", link: "Pune-to-Jejuri-Cab" },
        { place: "/images/keyword/5.jpg", text: "Pune Weekend Tour Packages", link: "Pune-Weekend-Tour-Packages" },
        { place: "/images/keyword/6.jpg", text: "Pune Darshan Packages", link: "Pune-Darshan-Packages" },
        { place: "/images/keyword/7.jpg", text: "Pune Sade Teen Shakti Peeth Bus on Rent", link: "Pune-Sade-Teen-Shakti-Peeth-Bus-on-Rent" },
        { place: "/images/keyword/8.jpg", text: "Pune Darshan Tempo Traveller on Rent", link: "Pune-Darshan-Tempo-Traveller-on-Rent" },
        { place: "/images/keyword/9.jpg", text: "Pune to Mysore Ooty Cab Package", link: "Pune-to-Mysore-Ooty-Cab-Package" },
        { place: "/images/keyword/10.jpg", text: "Pune to Mumbai Darshan Package", link: "Pune-to-Mumbai-Darshan-Package" },
        { place: "/images/keyword/11.jpg", text: "Pune to Ajanta Ellora Cab Service", link: "Pune-to-Ajanta-Ellora-Cab-Service" },
        { place: "/images/keyword/12.jpg", text: "Pune to Shirdi Darshan Package", link: "Pune-to-Shirdi-Darshan-Package" },
        { place: "/images/keyword/13.jpg", text: "Pune to Pandharpur Darshan", link: "Pune-to-Pandharpur-Darshan" },
        { place: "/images/keyword/14.jpg", text: "Hinjewadi Cab Service", link: "Hinjewadi-Cab-Service" },
        { place: "/images/keyword/15.jpg", text: "Cab Service in Wakad", link: "Cab-Service-in-Wakad" },
        { place: "/images/keyword/16.jpg", text: "Cab Service in Baner Pune", link: "Cab-Service-in-Baner-Pune" },
        { place: "/images/keyword/17.jpg", text: "Cab Service in Kharadi", link: "Cab-Service-in-Kharadi" },
        { place: "/images/keyword/18.jpg", text: "Cab Service in Hadapsar", link: "Cab-Service-in-Hadapsar" },
        { place: "/images/keyword/19.jpg", text: "Cab Service in Viman Nagar", link: "Cab-Service-in-Viman-Nagar" },
        { place: "/images/keyword/20.jpg", text: "Cab Service in Kothrud", link: "Cab-Service-in-Kothrud" },
        { place: "/images/keyword/21.jpg", text: "Cab Service in Pimpri Chinchwad", link: "Cab-Service-in-Pimpri-Chinchwad" },
        { place: "/images/keyword/22.jpg", text: "Cab Service in Wagholi Pune", link: "Cab-Service-in-Wagholi-Pune" },
        { place: "/images/keyword/23.jpg", text: "Pune to Trimbakeshwar Cab", link: "Pune-to-Trimbakeshwar-Cab" },
        { place: "/images/keyword/24.jpg", text: "Cab Service in Pune", link: "Cab-Service-in-Pune" },
        { place: "/images/keyword/25.jpg", text: "Outstation Taxi Service Pune", link: "Outstation-Taxi-Service-Pune" },
    ];













const productSchema = {
"@context": "https://schema.org",
"@type": "Product",
"name": "Pune to Shirdi Darshan Package",
"image": "https://www.risingcabservice.com/assets/images/pune-to-shirdi-darshan-package.jpg",
"description": "Book Pune to Shirdi Darshan Package with Rising Cab Service for comfortable Sai Baba temple visits and spiritual tours. Enjoy Shirdi and Shani Shingnapur darshan with safe, reliable, and affordable cab service from Pune.",
"brand": {
"@type": "Brand",
"name": "Rising Cab Service"
},
"aggregateRating": {
"@type": "AggregateRating",
"bestRating": "5",
"worstRating": "1",
"ratingValue": "4.8",
"ratingCount": "5471"
},
"offers": {
"@type": "Offer",
"priceCurrency": "INR",
"price": "Starting From ₹14/Km",
"availability": "https://schema.org/InStock",
"url": "https://www.risingcabservice.com/pune-to-shirdi-darshan-package"
}
};



    return (
        <div>


<Helmet>
  <title>Pune to Shirdi Darshan Package | Sai Baba Tour Cab | +91 9272511548</title>

<meta
 name="description"
 content="Book Pune to Shirdi Darshan Package for Sai Baba temple visit and Shani Shingnapur tour. Comfortable AC cab service with professional drivers for one-day and round-trip Shirdi travel from Pune."
/>

<meta
 name="keywords"
 content="Pune to shirdi package tour, Shirdi and shani shingnapur darshan package from pune, Shirdi darshan package from pune, Pune to Shirdi Darshan Package, Pune to Shirdi Tour Package, Pune to Shirdi Cab Package, Pune to Shirdi Sai Baba Darshan Package, Pune to Shirdi Darshan Cab, Pune to Shirdi One Day Tour, Pune to Shirdi Round Trip Cab, Pune to Shirdi Innova Crysta Cab"
/>

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>

</Helmet>



            <div
                className="breadcumb-wrapper"
                style={{
                    backgroundImage: "url('./img/bg/breadcrumb-bg.jpg')",
                    position: "relative",
                }}
            >
                <div
                    style={{
                        position: "absolute",
                        inset: 0,
                        backgroundColor: "rgba(0,0,0,0.3)",
                        zIndex: 1,
                    }}></div>

                <div className="container" style={{ position: "relative", zIndex: 2 }}>
                    <div className="breadcumb-content">
                        <h1 className="breadcumb-title"> {cardData.keyword}</h1>
                    </div>
                </div>
            </div>




















            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/12.jpg' alt='img' className='img-fluid' />
                            <h3 className="py-1"
                                style={{
                                    color: '#FF681A', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >Rising Cab Service: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="topPlaces">

                                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard borderr" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>

                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>


                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div key={index} className="service-row">
                                        {/* <div className="service-icon">
                      🚗
                    </div> */}
                                        <div>
                                            <h4 className="service-title">{service.name}</h4>
                                            <p className="service-desc">{service.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>


                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section" className="why-choose-section">


                                {/* Section Title */}
                                <h2 className="section-title text-white">
                                    Why Choose <span>Rising Cab Service</span>
                                </h2>


                                {/* Cards */}
                                <div className="cards-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div key={index} className="why-card">
                                            <div className="icon-circle">{index + 1}</div>
                                            <h4 className="card-heading">{item.WhyChooseheading}</h4>
                                            <p className="card-desc">{item.WhyChoosedescription}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Rising Cab Service </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase keyword={cardData.keyword} />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-telephone-fill"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+919272511548" className="pc-call">+91 9272511548</a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/919272511548"
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp"></i> WhatsApp
                                            </a>
                                            <a href="tel:+919272511548" className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-envelope-fill"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@risingcabservice.com" className="pc-email">
                                            booking@risingcabservice.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-geo-alt-fill"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Rising Cab Service</strong><br />

                                            A Unit of Atithya Dining LLP,
                                            901, 902 Deron Height, Baner Rd,
                                            Above Ranka Jewelers, Pune,
                                            Maharashtra -411069
                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Punetoshirdidarshanpackage;